export default __webpack_public_path__ + "static/media/avatar_tiger1.068c8e09.mp3";